
import {
	Component,
	Vue
} from 'vue-property-decorator';
import Switch from '@/components/switch.vue'
import PageFooter from '@/components/page-footer.vue';
import Dialog from '@/components/dialog.vue';
import Message from '@/components/message.vue';
import UploadImg from '@/components/upload-img.vue';
import qrCode from '@/components/qrCode.vue';
import viewableImg from '@/components/viewableImg.vue'
import { imgHost } from '@/utils/config'

import {
	productCategory,
	productCategorySave,
	productCategoryDelete,
	productCategoryIsJoinZoneRank,
	productCategoryIsOpenProductRetrieval
} from '@/api/supplier'

@Component({
	name: 'product-category',
	components: {
		'slz-switch': Switch,
		PageFooter,
		'slz-dialog': Dialog,
		'slz-message': Message,
		UploadImg,
		qrCode,
		viewableImg
	}
})
export default class ProductCategory extends Vue {
	private imgUrl = imgHost;
	private keywords = '';
	private showAddDialog = false;
	private showMessage = false
	private list: any = []
	private pageNo = 1;
	private pageSize = 10;
	private total = 0
	private formData: any = {
		Id: 0,
		CategoryName: '',
		Sort: '',
		ImgUrl: [],
		SharePoster: []
	}
	private deleteData: any = {};
	private showcode = false
	private codemsg: any = {}

	private retrievalData: any = {
		IsOpenProductRetrieval: false,
		TargetCollectionMoney: null,
		Id: ''
	}
	private showRetrieval = false;

	private mounted() {
		this.getList();
	}

	private handleEditProductRetrieval(record){
		for(let item in this.retrievalData){
			if (item === 'TargetCollectionMoney' && record[item] === 0){
				this.retrievalData[item] = null;
			}else{
				this.retrievalData[item] = record[item];
			}
		}
		this.showRetrieval = true;
	}
	private async handleSaveRetrieval(){
		console.log(this.retrievalData)
		try {
			const res: any = await productCategoryIsOpenProductRetrieval(this.retrievalData);
			this.$message({
				type: 'success',
				message: '编辑成功！'
			})
			this.showRetrieval = false;
			this.getList();
		} catch (error) {

		}
	}

	private addRank(record) {
		let addMsg = '加入专区排行后，在B端APP—团长带货榜中显示对应分类筛选，系统将根据该分类下的商品，对团长带货额进行统计与排名，是否确认加入？';
		let cancelMsg = '是否确认取消专区排行？';
		this.$confirm(record.IsJoinZoneRank ? cancelMsg : addMsg, '提示', {
			confirmButtonText: '确认',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			try {
				await productCategoryIsJoinZoneRank({ Id: record.Id, IsJoinZoneRank: !record.IsJoinZoneRank });
				this.$message.success('操作成功');
				this.doSearch();
			} catch (error) {

			}
		}).catch(() => {
		});
	}

	private promote(row) {
		// console.log(row)
		this.codemsg = {
			type: 2,
			Id: row.Id,
			title: row.CategoryName
		}
		this.showcode = true
	}
	private doSearch() {
		this.pageNo = 1;
		this.getList();
	}

	private doClear() {
		this.keywords = '';
		this.pageNo = 1;
		this.getList();
	}

	// 获取列表
	private async getList() {
		let params: any = {
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			Keywords: this.keywords
		}
		try {
			const res: any = await productCategory(params);
			this.list = res.Result.Results;
			this.total = res.Result.Total;
		} catch (err) {
			console.error('getProviderStatistics ===>', err)
		}
	}

	private pageChange(num: number) {
		this.pageNo = num;
		this.getList();
	}

	/**
	 * 展示弹窗
	 */
	private handleShow() {
		for (let item in this.formData) {
			this.formData[item] = '',
				this.formData.ImgUrl = []
			this.formData.SharePoster = []
		}
		this.showAddDialog = true;
	}

	// 上传图片成功回调
	private uploadSuc(list: any, key: string) {
		this.formData[key] = list
	}

	/**
	 * 添加分类确认
	 */
	private async addConfirm() {

		if (!this.formData.CategoryName) {
			this.$message({
				type: 'warning',
				message: '请输入分类名称'
			})
			return;
		}

		try {
			let data: any = this.formData
			if (data.ImgUrl && data.ImgUrl.length) {
				data.ImgUrl = data.ImgUrl[0]
			} else {
				data.ImgUrl = ''
			}
			if (data.SharePoster && data.SharePoster.length) {
				data.SharePoster = data.SharePoster[0]
			} else {
				data.SharePoster = ''
			}
			const res: any = await productCategorySave(data);
			this.$message({
				type: 'success',
				message: '编辑成功！'
			})
			this.getList();
		} catch (error) {

		}

		this.showAddDialog = false;
	}

	/**
	 * 添加分类取消
	 */
	private addCancel() {
		this.showAddDialog = false;
	}

	/**
	 * 跳转到管理页面
	 */
	private toDetail(record: any) {
		setTimeout(() => {
			var obj = {}
			for (let item in this.formData) {
				if (item == 'ImgUrl' || item == 'SharePoster') {
					obj[item] = record[item] ? [record[item]] : []
				} else {
					obj[item] = record[item]
				}
			}
			this.formData = obj;
			// console.log(this.formData)
		}, 100)
		this.showAddDialog = true;
	}

	private toDelete(record: any) {
		this.deleteData = record;
		this.showMessage = true;
	}

	private async handleConfirm() {
		try {
			const res: any = await productCategoryDelete({
				Id: this.deleteData.Id
			})

			this.$message({
				type: 'success',
				message: '删除成功！'
			})
			this.getList();
		} catch (error) {

		}
	}
}
